import http from "@/services/http";

export const ConversationService = {
  fetchAllForUser: () => {
    return http.get("/conversations");
  },
  fetchById: ({ conversationId }) => {
    return http.get(`/conversations/${conversationId}`);
  },
  findOrCreateByParticipantIds: ({ participantIds }) => {
    return http.post("/conversations", { participant_ids: participantIds });
  },
};
